import Bowser from 'bowser';
import config from 'config';
import memoizeOne from 'memoize-one';

export function isBrowserSupported(userAgent?: string) {
  if (!userAgent) {
    return true;
  } // Default to true
  const { minimumBrowserVersion } = config;

  const matchesUnsupportedBrowser = Bowser.getParser(userAgent).satisfies({
    safari: `<${minimumBrowserVersion.safari}`,
    chrome: `<${minimumBrowserVersion.chrome}`,
    firefox: `<${minimumBrowserVersion.firefox}`,
    opera: `<${minimumBrowserVersion.opera}`,
    'internet explorer': '<=11',
    'Microsoft Edge': `<${minimumBrowserVersion.edge}`,
    Vivaldi: `<${minimumBrowserVersion.vivaldi}`,
    electron: `<${minimumBrowserVersion.electron}`,
  });

  const isSupported =
    matchesUnsupportedBrowser === undefined || matchesUnsupportedBrowser === false;

  return isSupported;
}

export const getBrowserMeta = memoizeOne((userAgent: string = window.navigator.userAgent) => {
  return {
    name: (!!userAgent && Bowser.getParser(userAgent).getBrowser().name) || 'Unknown',
    isSupported: isBrowserSupported(userAgent),
    isDesktopApp: !!userAgent && userAgent.indexOf('Timely/') !== -1,
  };
});

export const getLocaleFromBrowser = () => {
  try {
    const browserLocale =
      (window.navigator.languages && window.navigator.languages[0]) ||
      window.navigator.language ||
      'en-US';

    // Will throw RangeError if the locale is invalid
    // See https://linear.app/timelyapp/issue/TT-3086/%5Bbug%5D-rangeerror-incorrect-locale-information-provided-on-hours-page
    new Intl.NumberFormat(browserLocale);
    return browserLocale;
  } catch (error) {
    console.warn('Invalid browser locale detected, using fallback', error);
    return 'en-US';
  }
};
